import styled, { css } from 'styled-components';
import { Overlay } from '@fluentui/react';
import { RadioGroup } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';
import { AddSkillDivider } from '../../common/styles/common.styled';

export const SkillsEditPopupOverlay = styled(isMobile ? styled.div`` : Overlay)`
  background: ${(props) => props.theme.skillsAccordionBackground};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  width: 476px;
  height: fit-content;
  margin: auto;
  overflow-x: hidden;
  border-radius: 2px;
  max-height: 100svh;

  @media (max-width: 710px) {
    height: 100svh;
    width: 100%;
    overflow-y: scroll;
    position: absolute;

    p {
      font-size: 17px;
      font-weight: 400;
      color: #424242;
    }
  }
`;

export const SkillsMiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 20px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 20px;
  &:first-child {
    margin-bottom: 16px;
  }

  @media (max-width: 710px) {
    padding-bottom: 0;
  }
`;

export const RadioGroupStyled = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  width: 300px;
  span {
    width: 100%;
  }
  input {
    position: absolute;
    width: 20px;
  }
  label {
    font-size: 13px;
  }

  @media (max-width: 710px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`;

export const FinishingActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  justify-content: flex-end;

  @media (max-width: 710px) {
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    position: fixed;
    bottom: 0;
    background: ${(props) => props.theme.skillsAccordionBackground};
  }
`;

export const AccordionPanelLeftColumnTextStyle = styled.p`
  color: ${(props) => props.theme.skillsSecondaryTextColor} !important;
  font-size: 12px !important;
  font-weight: 400;
`;

export const AccordionPanelRightColumnTextStyle = styled.p`
  color: ${(props) => props.theme.skillsMainTextColor} !important;
  font-size: 14px !important;
  font-weight: 400;
  word-break: break-all;
  word-wrap: keep-all;
`;

export const EditUlStyledRequested = styled.ul<{ isMobile?: boolean }>`
  ${({ isMobile }) => {
    if (isMobile) {
      return 'padding-left: 20px;';
    }
  }}
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const EditMiddleWrapperGrid = styled.ul<{ isMobile?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: repeat(2, auto);
  grid-template-areas:
    'validated-header requested-header'
    'data data';
  margin-top: 12px;
  gap: 10px;

  ${() => {
    if (isMobile) {
      return mobileStyles;
    }
  }};
`;

const mobileStyles = ` 
    grid-template-columns: repeat(2, auto);
    grid-column-gap: 20px;
  
    #requested-date-label, #requested-level-label,  #requested-attitude-label {
      display: none;
  }
`;

export const EditMiddleWrapperSubGrid = styled.ul`
  grid-area: data;
  display: grid;
  grid-template-rows: repeat(4, auto);
  grid-template-columns: auto 1fr auto 1fr;

  grid-template-areas:
    'validated-date-label validated-date-value requested-date-label requested-date-value'
    'validated-level-label validated-level-value requested-level-label requested-level-value'
    'validated-attitude-label validated-attitude-value requested-attitude-label requested-attitude-value'
    'validated-by-label validated-by-value validated-by-value validated-by-value';
  gap: 10px;

  ${() => {
    if (isMobile) {
      return subgridMobileStyles;
    }
  }};
`;

const subgridMobileStyles = `
  grid-template-columns: 45px 1fr 1fr; 
  grid-template-areas: 'validated-date-label validated-date-value requested-date-value'
    'validated-level-label validated-level-value requested-level-value'
    'validated-attitude-label validated-attitude-value requested-attitude-value'
    'validated-by-label validated-by-value validated-by-value';
  gap: 5px 10px;
`;

export const EditUlStyledValidated = styled(EditUlStyledRequested)``;

export const EditLiStyled = styled.li<{ gridArea?: string }>`
  list-style: none;

  ${({ gridArea }) => {
    if (gridArea) {
      return `grid-area: ${gridArea};`;
    }
  }}
`;

export const EditRequestInfoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
`;

export const EditMiddleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 412px;

  @media (max-width: 480px) {
    #validated-container {
      width: 80%;
    }
  }

  @media (max-width: 710px) {
    margin-top: 24px;
    margin-bottom: 24px;
    width: 100%;
  }
`;

export const EditStatusWrapper = styled.div<{ gridArea?: string }>`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;

  ${({ gridArea }) => {
    if (gridArea) {
      return `grid-area: ${gridArea};`;
    }
  }}
`;

export const EditSelectedInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const EditSelectedTitleStyle = styled.p`
  width: 70px;
  font-size: 12px;
  font-weight: 600;
  color: #5b5fc7 !important;
`;

export const EditSelectedInfoStyle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.skillsMainTextColor} !important;
  word-break: break-all;
`;

const dividerMobileStyle = css`
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 90%;
  background: #d1d1d1 !important;
`;

export const EditDividerStyle = styled(AddSkillDivider)<{ isMobile?: boolean }>`
  width: 100%;
  margin: 12px 0;
  ${({ isMobile }) => {
    if (isMobile) {
      return dividerMobileStyle;
    }
  }}
`;

export const EditInfoContainer = styled.div`
  width: 100%;
  @media (max-width: 480px) {
    width: auto;
  }
`;

export const SpinnerContainer = styled.div<{ isMobile?: boolean }>`
  height: 50svh;

  ${({ isMobile }) =>
    isMobile &&
    `
    height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
  `}
`;
